import React from "react";

const ReadMore=({...restprops})=>{
    return(
        <>
          <button className="read_more_btn" {...restprops} >Read More</button>
        </>
    );
}
export {ReadMore};